export const resolveRegionString = () => {
    if (window.__ENV__ === 'PRODUCTION') {
        return "US"
    } else {
        return 'QA'
    }
}
